import { render, staticRenderFns } from "./moreHot.vue?vue&type=template&id=2f7e582c&scoped=true&"
import script from "./moreHot.vue?vue&type=script&lang=js&"
export * from "./moreHot.vue?vue&type=script&lang=js&"
import style0 from "./moreHot.vue?vue&type=style&index=0&id=2f7e582c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7e582c",
  null
  
)

export default component.exports